import { Component, ViewChild, EventEmitter, Output } from "@angular/core";
import { AdvanceSearchComponent } from "./advancesearch/advancesearch.component";
import { SimpleSearchComponent } from "./simplesearch/simplesearch.component";
import { OffrecommercialeService } from "./offrecommerciale.service";
import { OffreCommercialeLight } from "./model/offreCommercialeLight";
import { MapComponent } from "../map/map.component";
import { TranslateService } from "@ngx-translate/core";
import { OffreLightByTypeTouche } from "./model/offreLightByTypeTouche";
import { RechercheOffresCommercialesFormNom } from "./model/form/rechercheOffreCommercialFormNom";
import { UserInformaions } from "../common/userinformations";
import * as L from "leaflet";
import { MatSnackBar } from "@angular/material";
import { GeocodingService } from "../geocoding.service";
import { MarkerInfos } from "../map/markerInfos";
import { Location } from "../location";
import { PortService } from "../port/port.service";
import { Port } from "../port/model/port";

@Component({
  selector: "search-offre",
  templateUrl: "./offreCommercialeSearch.component.html"
})
export class OffreCommercialeSearchComponent {
  @ViewChild(AdvanceSearchComponent)
  private advanceSearchComponent: AdvanceSearchComponent;

  @ViewChild(SimpleSearchComponent)
  private simpleSearchComponent: SimpleSearchComponent;

  @ViewChild(MapComponent)
  private mappComponent: MapComponent;

  @Output()
  showDetailOffreEmitter = new EventEmitter<OffreCommercialeLight>();

  @Output()
  letHasResultEmitter = new EventEmitter<boolean>();

  @Output()
  addMarkerEmitter = new EventEmitter<MarkerInfos>();

  @Output()
  addMarkerSearchEmitter = new EventEmitter<MarkerInfos>();

  VISIBLE_TOKEN = "visible";
  ACTIVE_TOKEN = "active";
  DISPLAY_BLOCK = "block";
  DISPLAY_NONE = "none";
  MSG_NO_RESULTAT_RECHERCHE = "Pas de .form-ctrl recherche ";
  EMPTY_TOKEN = "";
  PORT_MARKER_NOT_VISIBLE = "MARSEILLE";

  simpleResultActive: string = this.EMPTY_TOKEN;
  advanceResultActive: string = this.EMPTY_TOKEN;
  formSearchActive: string = this.ACTIVE_TOKEN;
  leftPanelVisible: string = this.EMPTY_TOKEN;
  noResult: string = this.DISPLAY_NONE;
  aucunService: string = this.DISPLAY_NONE;
  nbrServices = null;
  isLastSearchLaunchAdvance = false;

  directResult: Array<any>;
  transboResult: Array<any>;
  searchForm: RechercheOffresCommercialesFormNom;
  portsTouches: Port[];
  BTN_PRIMARY = "btn-primary";
  familleDirect: string = "DIRECT";
  familleTransbo: string = "TRANSBORDEMENT";
  empreinteMoyenne: number;

  /*Variable d'internationalisation*/
  LRM;

  constructor(
    public offreService: OffrecommercialeService,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    private portsService: PortService,
    private geocoder: GeocodingService
  ) {
    this.translate.get("LRM").subscribe(res => {
      this.LRM = res;
    });
  }

  ngOnInit() {
    /* Récupération des ports touchés qui seront utiliser pour la recherche simple/avancé */
    this.portsService.getAllPortsTouches().subscribe(data => {
      this.portsTouches = data;
      this.simpleSearchComponent.portsTouches = data;
      this.advanceSearchComponent.portsTouches = data;
      for (let i = 0; i < this.portsTouches.length; i++) {
        const location = new Location();
        location.latlng = L.latLng(1, 1);
        if (!this.portsTouches[i].lat) {
          location.latlng = L.latLng(1, 1);
        } else {
          location.latlng = L.latLng(
            this.portsTouches[i].lat,
            this.portsTouches[i].lon
          );
        }
        let markerInfo: MarkerInfos = new MarkerInfos(
          this.portsTouches[i].id,
          location.latlng,
          this.portsTouches[i].nom,
          this.portsTouches[i].flag,
          this.portsTouches[i].pays,
          false
        );
        if (this.portsTouches[i].nom != this.PORT_MARKER_NOT_VISIBLE) {
          this.addMarkerEmitter.emit(markerInfo);
        }
      }
    });
  }
  /* Retourne le component de la recherche simple */
  getSimpleSearchComponent() {
    return this.simpleSearchComponent;
  }

  /* Retourne le component de la recherche avancé */
  getAdvanceSearchComponent() {
    return this.advanceSearchComponent;
  }
  /* Retourne le component de la recherche avancé */
  getMappComponent() {
    return this.mappComponent;
  }
  /* Pas de résultat suite à une recherche */
  noResultSearch(advanceSearch: boolean) {
    if (advanceSearch) {
      this.simpleSearchComponent.fromValue = this.advanceSearchComponent.fromValue;
      this.simpleSearchComponent.toValue = this.advanceSearchComponent.toValue;
    } else {
      this.advanceSearchComponent.fromValue = this.simpleSearchComponent.fromValue;
      this.advanceSearchComponent.toValue = this.simpleSearchComponent.toValue;
    }
    this.letHasResults(false);
    this.aucunService = this.DISPLAY_NONE;
    this.noResult = this.DISPLAY_BLOCK;
    this.formSearchActive = this.ACTIVE_TOKEN;
    this.simpleResultActive = this.EMPTY_TOKEN;
    this.advanceResultActive = this.EMPTY_TOKEN;
  }

  /* Afficher le message Aucun service trouvé pour le port recherché. Nous vous proposons le port touché le plus proche */
  aucunServicePourLePortRecherche(isTrue: boolean) {
    if (isTrue) {
      this.noResult = this.DISPLAY_NONE;
      this.aucunService = this.DISPLAY_BLOCK;
    } else {
      this.noResult = this.DISPLAY_NONE;
      this.aucunService = this.DISPLAY_NONE;
    }
  }

  onRechercheOffrecommerciale(
    searchResult: OffreLightByTypeTouche,
    advanceSearch: boolean
  ) {
    /*Rendre le bouton rechercher obligatoire   */
    this.advanceSearchComponent.disabledSearch = false;
    this.advanceSearchComponent.btnPrimaryOrDefault = this.BTN_PRIMARY;
    /*Synchronisation des informations entre la bar de recherche simple et avancé*/
    if (advanceSearch) {
      this.simpleSearchComponent.fromValue = this.advanceSearchComponent.fromValue;
      this.simpleSearchComponent.toValue = this.advanceSearchComponent.toValue;
    } else {
      this.advanceSearchComponent.fromValue = this.simpleSearchComponent.fromValue;
      this.advanceSearchComponent.toValue = this.simpleSearchComponent.toValue;
    }

    this.initSearchValue();
    this.isLastSearchLaunchAdvance = advanceSearch;
    /* traitement des données */
    if (searchResult) {
      this.directResult = Object.entries(searchResult.direct);
      this.transboResult = Object.entries(searchResult.transbo);
    }

    if (
      (this.directResult && this.directResult.length > 0) ||
      (this.transboResult && this.transboResult.length > 0)
    ) {
      /* Cacher la page résultat */
      this.nbrServices = 0;
      /** calculer le nombres d'offres */
      this.transboResult.forEach(offre => {
        this.nbrServices += offre[1].length;
      });
      this.directResult.forEach(offre => {
        this.nbrServices += offre[1].length;
      });

      this.formSearchActive = this.EMPTY_TOKEN;
      this.letHasResults(true);

      if (advanceSearch) {
        this.simpleResultActive = this.EMPTY_TOKEN;
        this.searchForm = this.advanceSearchComponent.searchFormModel;
        this.advanceResultActive = this.ACTIVE_TOKEN;
      } else {
        this.advanceResultActive = this.EMPTY_TOKEN;
        this.searchForm = this.simpleSearchComponent.searchFormModel;
        this.simpleResultActive = this.ACTIVE_TOKEN;
      }
      /* Afficher les informations sur le panel gauche */
      this.leftPanelVisible = this.VISIBLE_TOKEN;
    } else {
      this.letHasResults(false);
    }
  }

  /* initialiser les l'ihm */
  initSearchValue() {
    this.noResult = this.DISPLAY_NONE;
    this.directResult = null;
    this.transboResult = null;
  }

  /* Afficher/Cacher le panel gauche qui contient soit le formulaire de recherche avancé soit le résultat de la recherche */
  showHidePanel() {
    if (this.leftPanelVisible === this.VISIBLE_TOKEN) {
      this.leftPanelVisible = this.EMPTY_TOKEN;
    } else {
      this.leftPanelVisible = this.VISIBLE_TOKEN;
      if (
        this.simpleResultActive === this.EMPTY_TOKEN &&
        this.advanceResultActive === this.EMPTY_TOKEN
      ) {
        this.formSearchActive = this.ACTIVE_TOKEN;
      }
    }
  }

  /* Afficher le panel gauche qui contient le formulaire de recherche avancé */
  showAdvanceForm() {
    /* Cacher la page résultat */
    this.simpleResultActive = this.EMPTY_TOKEN;
    this.advanceResultActive = this.EMPTY_TOKEN;

    /* Afficher le panel puis afficher le formulaire de recherche avancé */
    this.leftPanelVisible = this.VISIBLE_TOKEN;
    this.formSearchActive = this.ACTIVE_TOKEN;
  }

  /* Afficher la fenêtre popup qui contient le détail d'une offre commerciale selectionné */
  showDetail(offre: OffreCommercialeLight) {
    this.showDetailOffreEmitter.emit(offre);
  }

  /* récupèrer l'objet qui contient toutes les valeurs saisies dans le formulaire de recherche*/
  getSearchForm(): RechercheOffresCommercialesFormNom {
    return this.searchForm;
  }

  /* Ajouter la class css qui permet de dire qu'on passe vers l'état d'une page avec des résultats */
  letHasResults(hasResults: boolean) {
    this.letHasResultEmitter.emit(hasResults);
  }

  /* stockage des informations de l'utilisateurs pour les envoyer lors d'une recherche */
  setUserInformations(userInformations: UserInformaions) {
    this.simpleSearchComponent.setUserInformations(userInformations);
    this.advanceSearchComponent.setUserInformations(userInformations);
  }

  /*PARTIE RECHERCHE GEOCODING*/
  gotoSearch(markerInfos: MarkerInfos) {
    let iscolor: boolean = markerInfos.islocalite;
    if (!markerInfos.nom) {
      return;
    }

    let marker: MarkerInfos = new MarkerInfos(
      markerInfos.id,
      markerInfos.coord,
      markerInfos.nom,
      markerInfos.flag,
      markerInfos.pays,
      iscolor
    );
    marker.setLinkedMarker(markerInfos.getLinkedMarker());
    this.addMarkerSearchEmitter.emit(marker);
  }

  addMarker(markerInfos: MarkerInfos) {
    this.addMarkerEmitter.emit(markerInfos);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/offreCommercialeSearch.component.ts